import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdminService} from '../../services/admin.service';

@Component({
  selector: 'app-national-dialog',
  templateUrl: './national-dialog.component.html',
  styleUrls: ['./national-dialog.component.scss']
})
export class NationalDialogComponent {
  nationalGameForm: FormGroup;
  isEditMode: boolean;
  selectedHomeFile: File | null = null;
  selectedAwayFile: File | null = null;
  date = new Date();

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<NationalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nationalGames: any }
  ) {
    this.isEditMode = !!data.nationalGames?.id;

    const dateTime = data.nationalGames?.gameDate || '';
    const [datePart, timePart] = dateTime ? dateTime.split('T') : ['', ''];

    this.nationalGameForm = this.fb.group({
      homeTeamLogo: [data.nationalGames?.homeTeamLogo || ''],
      awayTeamLogo: [data.nationalGames?.awayTeamLogo || ''],
      homeTeam: [data.nationalGames?.homeTeam || '', Validators.required],
      awayTeam: [data.nationalGames?.awayTeam || '', Validators.required],
      leagueType: [data.nationalGames?.leagueType || '', Validators.required],
      status: [data.nationalGames?.status || '', Validators.required],
      gameDate: [datePart || '', Validators.required],
      gameTime: [timePart || '', Validators.required]
    });
  }

  saveGame() {
    if (this.nationalGameForm.valid) {
      let { gameDate, gameTime, homeTeamLogo, awayTeamLogo, ...otherData } = this.nationalGameForm.value;

      const originalGameDate = this.data.nationalGames?.gameDate.split("T")[0];

      let gameDateObj = new Date(gameDate);

      if (gameDate !== originalGameDate) {
        gameDateObj.setDate(gameDateObj.getDate() + 1);
      }

      const formattedDate = gameDateObj.toISOString().split("T")[0];

      const formattedTime = gameTime.length === 5 ? `${gameTime}:00.000Z` : gameTime;

      const gameDateTime = `${formattedDate}T${formattedTime}`;

      const gameData = {
        ...otherData,
        gameDate: gameDateTime,
      };

      this.adminService.updateGame(this.data.nationalGames.id, gameData).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  onHomeTeamLogoChange(event: Event) {
    this.handleFileChange(event, 'home');
  }

  onAwayTeamLogoChange(event: Event) {
    this.handleFileChange(event, 'away');
  }

  private handleFileChange(event: Event, type: 'home' | 'away') {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        if (type === 'home') {
          this.selectedHomeFile = e.target.result;
        } else {
          this.selectedAwayFile = e.target.result;
        }
      };
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append('image', file);
      if (type === 'home') {
        this.adminService.insertHomeTeamLogo(this.data.nationalGames.id, file).subscribe();
      } else {
        this.adminService.insertAwayTeamLogo(this.data.nationalGames.id, file).subscribe();
      }
    }
  }

}
